import { __decorate, __metadata } from "tslib";
import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { ImageComponent, TextComponent, UnknownComponent } from './sdks';
import { Addon, ApiConfig } from '../../limitPrivateAPI';
const TEXT_COMPONENT_TYPES = [
    'wysiwyg.viewer.components.WRichText',
    'wixui.CollapsibleText',
];
const IMAGE_COMPONENT_TYPES = [
    'wysiwyg.viewer.components.WPhoto',
    'wixui.ImageX',
];
function getComponentsFactory(compType) {
    if (TEXT_COMPONENT_TYPES.includes(compType)) {
        return TextComponent;
    }
    else if (IMAGE_COMPONENT_TYPES.includes(compType)) {
        return ImageComponent;
    }
    return null;
}
export class ComponentsNamespace extends PrivateAPINamespace {
    async getSelectedComponents() {
        return this.ps.hostAPI.editor.selection.getSelectedComponents();
    }
    async getComponent(compRef) {
        const compType = this.ps.ds.components.getType(compRef);
        const Factory = getComponentsFactory(compType);
        if (!Factory) {
            return new UnknownComponent(compRef, compType);
        }
        const sdk = new Factory(compRef, this.ps);
        await sdk.init();
        return sdk;
    }
}
ComponentsNamespace.namespace = 'components';
__decorate([
    ApiConfig(Addon),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], ComponentsNamespace.prototype, "getSelectedComponents", null);
__decorate([
    ApiConfig(Addon),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], ComponentsNamespace.prototype, "getComponent", null);
//# sourceMappingURL=ComponentsNamespace.js.map